
<template>
   <div id="data-list-list-view" class="data-list-container">
       <vs-card>
            <div class="vx-row">
              <div class="vx-col lg:w-1/4 w-full mt-5">
        <p>{{$t('IndustrySector')}}</p>
          <v-select
            label="Name"
            v-model="searchModel.industrySectors"
            :options="getindustrySector" 
            autocomplete multiple
            class="w-full"
            :reduce="value => value.ID"
          />
              </div>
             
                     <div class="vx-col lg:w-1/4 w-full mt-5">
        <p>{{$t('AreaOfStudy')}}</p>
          <v-select
            label="Name"
            v-model="searchModel.areaOfStudies"
            :options="getCourseAreaOfStudyList" 
            autocomplete multiple
            class="w-full"
            :reduce="value => value.ID"
          />
              </div>
              
                    <div class="vx-col lg:w-1/4 w-full mt-5">
        <p>{{$t('Language')}}</p>
          <v-select
            label="Name"
            v-model="searchModel.languages"
            :options="getLanguage" 
            autocomplete multiple
            class="w-full"
            :reduce="value => value.ID"
          />
              </div>
                <!-- <vs-select   multiple autocomplete class="vx-col lg:w-1/4 w-full mt-5" label="language" v-model="searchModel.languages">
                    <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in getLanguage" />
                </vs-select> -->
                    <div class="vx-col lg:w-1/4 w-full mt-5">
        <p>{{$t('Level')}}</p>
          <v-select
            label="Name"
            v-model="searchModel.CourseLevels"
            :options="getCourseLevel" 
            autocomplete multiple
            class="w-full"
            :reduce="value => value.ID"
          />
              </div>
           
            </div>
             <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="mt-8 flex flex-wrap items-center justify-end">
                        <vs-button class="mr-6" @click="search" >{{$t('Search')}}</vs-button>
                        <vs-button type="border" color="danger" @click="reset">{{$t('Reset')}}</vs-button>
                    </div>
                </div>
            </div>
       </vs-card>
       <div class="vx-row justify-between">
          <div class="vx-col lg:w-3/4 vx-row mt-5">
            <span class="vx-col" style="margin-top:25px"> {{$t('SortBy')}} :</span>
                <div class="vx-col lg:w-1/4 w-full mt-5">
        
          <v-select
            label="Name"
            v-model="searchModel.SortBy"
            :options="sortList" 
            autocomplete 
            class="mt-5 w-full"
            :reduce="value => value.ID"
            @input="search"
          />
              </div>
            <!-- <vs-select  autocomplete class="vx-col lg:w-1/4 w-full mt-5" v-model="searchModel.SortBy" @change="search()">
                  <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in sortList" />
            </vs-select> -->
          </div>
          <div class="vx-col mt-5">
            <template>
                <vs-pagination :total="totalPages" v-model="currentx"></vs-pagination>
            </template>
          </div>
        </div>
       <div class="vx-row mt-5">
         <div class="vx-col lg:w-1/2 w-full" v-for="item in tracks" :key="item.ID">
            <vs-card >
                  <div class="vx-row" @click="viewDateil(item)" style="cursor:pointer">
                    <div class="vx-col w-full">
                        <h3 >{{item.Name}}</h3>
                        <h6 class="mt-2"> {{$t('Provider')}}: <span v-if="item.ProviderID!=null">{{item.Provider.Name}}</span><span v-if="item.ProviderID==null">UATS</span> </h6>
                        <h6 class="mt-2">Code: {{item.Code}}</h6>
                        <p class="mt-2">{{item.About}}</p>
                        <div class="vx-row mt-2" style="margin-left:2px">
                             <h6  v-for="le in item.TrackLanguages" :key="le.ID">{{le.Language.Name}}|</h6>
                        </div>
                    </div>
                   
                  </div>
            </vs-card>
         </div>
       </div>
        <template>
                <vs-pagination :total="totalPages" v-model="currentx"></vs-pagination>
        </template>
   </div>
</template>

<script>
import moduleCourseLevel from "@/store/settings/courseLevel/moduleCourseLevel.js";
import moduleLanguage from "@/store/settings/language/moduleLanguage.js";
import moduleIndustrySector from "@/store/settings/industrySector/moduleIndustrySector.js";
import moduleCourseAreaOfStudy from "@/store/settings/courseAreaOfStudy/moduleCourseAreaOfStudy.js";
import moduleTrack from "@/store/track/moduleTrack.js";
import vSelect from 'vue-select'
 export default {
       components: {
       vSelect,
  },
  data() {
    return {
      itemsPerPage:10,
      currentx:1,
      one_day : 1000 * 60 * 60 * 24,
      sortList:[{ID:1,Name:"Title A-Z"},{ID:2,Name:"Title Z-A"}],
     searchModel:{},
      isMounted: false,
    };
  },
  computed: {
     tracks() {
      return this.$store.state.trackList.tracks;
    },
    totalPages () {
            return Math.ceil(this.tracks.length / this.itemsPerPage)
        },
  
    getCourseLevel()
    {
        return this.$store.state.courseLevelList.courseLevels;
    },
     getLanguage()
    {
        return this.$store.state.languageList.languages;
    },
    
      getindustrySector()
    {
        return this.$store.state.industrySectorList.industrySectors;
    },
    getCourseAreaOfStudyList()
    {
      return this.$store.state.courseAreaOfStudyList.courseAreaOfStudies;
    },
  
  },

  methods: {
    viewDateil(program)
    {
         this.$router.push({name: 'diploma_programs', params: { ID: program.ID}});
    },
    Registration(annualPlan)
    {
         this.$router.push({name: 'ConfirmRegistration', params: { ID: annualPlan.ID}});
    },
     getDaysBetweenTowDate(dateFrom,dateTo)
    {
         return  Math.round(new Date(dateTo.split('T')[0]).getTime()-new Date(dateFrom.split('T')[0]).getTime())/ (this.one_day);
    }, 
    search(){

       this.$store.dispatch("trackList/fetchDataListItemsByFilter", this.searchModel).catch(err => {
        console.error(err);
      }); 

    },
    reset(){
        this.$router.go(this.$router.currentRoute);
    },
    initDate(){
      //this.searchModel.SortBy=1;
        this.searchModel.industrySectors=[];
        this.searchModel.areaOfStudies=[];
        this.searchModel.languages=[];
        this.searchModel.CourseLevels=[];
    }
  },

  created() {
      this.initDate();
      debugger
       if (!moduleCourseLevel.isRegistered) {
      this.$store.registerModule("courseLevelList", moduleCourseLevel);
      moduleCourseLevel.isRegistered = true;
    }
     if (!moduleLanguage.isRegistered) {
      this.$store.registerModule("languageList", moduleLanguage);
      moduleLanguage.isRegistered = true;
    }
       if (!moduleIndustrySector.isRegistered) {
      this.$store.registerModule("industrySectorList", moduleIndustrySector);
      moduleIndustrySector.isRegistered = true;
    }
     if (!moduleCourseAreaOfStudy.isRegistered) {
      this.$store.registerModule("courseAreaOfStudyList", moduleCourseAreaOfStudy);
      moduleCourseAreaOfStudy.isRegistered = true;
    }
    if (!moduleTrack.isRegistered) {
      this.$store.registerModule("trackList", moduleTrack);
      moduleTrack.isRegistered = true;
    }
      this.$store.dispatch("trackList/fetchDataListItems"); 
    this.$store.dispatch("courseAreaOfStudyList/fetchDataListItems");
    this.$store.dispatch("industrySectorList/fetchDataListItems");
    this.$store.dispatch("languageList/fetchDataListItems");
    this.$store.dispatch("courseLevelList/fetchDataListItems");
  },
  mounted() {
    this.isMounted = true;
  },
  
    }
</script>


<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
  input[type="color" i]{
    height: 35px!important;
  }
  #colorPicer .vs-input--input.normal
  {
  padding: 0.2rem
  }
</style>
<style>
.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large){
  padding: .75rem 1rem
}
</style>